module.exports = __webpack_public_path__ + "static/media/02.15711b3a.jpg";